import React from "react";
import "./auth.scss";
import onco_mark from "../../assets/logos/ONCOEVIDA_1.png";
import ForgotPassForm from "../../components/Forms/AuthForms/ForgotPassForm";

const ForgotPassword = () => {
  return (
    <div className="myCustomLogin">
      <div className="logoPart container">
        <div className="logoContainer">
          <img src={onco_mark} alt="" style={{ width: "50%" }} />
        </div>
        <h2 className="form-header mt-2">Password Reset</h2>
        <p className="form-desc">
          Please provide the email and we will send you instructions for
          resetting your password.
        </p>
        <div className="formPart">
          <ForgotPassForm />
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
